import api from "../../axios";

const getAccountId = () => {
  return sessionStorage.getItem("acc_id");
};

const getPatientId = () => {
  return sessionStorage.getItem("_pt_id");
};

export async function createBillingCode(data) {
  const tenantId = getAccountId();
  const response = await api.post(`/billing/${tenantId}/billing-codes/`, data);
  return response.data;
}

export async function deleteBillingCode(id) {
  const tenantId = getAccountId();
  const response = await api.delete(
    `/billing/${tenantId}/billing-codes/${id}/`
  );
  return response.data;
}

export async function getBillingCodes(category) {
  const tenantId = getAccountId();
  const response = await api.get(`/billing/${tenantId}/billing-codes/`, {
    params: {
      category: category,
    },
  });
  return response.data;
}

export async function updateBillingCode(id, data) {
  const tenantId = getAccountId();
  const response = await api.patch(
    `/billing/${tenantId}/billing-codes/${id}/`,
    data
  );
  return response.data;
}
